import Vue from 'vue'

// Причины 401 от api/publications/*, когда публикация открывается только по паролю
const ACCESS_REASONS = ['PasswordRequired', 'PasswordChanged']

// Отдельно от Vuex: доступ переключает слой запросов, а store импортирует его же (цикл импортов)
export const access = Vue.observable({
  locked: false,
  reason: null,
  // Куда шёл пользователь: остановленная навигация сбрасывает хэш на #/, а после ввода
  // пароля нужно открыть ту же страницу класса или учителя, что была в ссылке
  returnPath: null,
})

export function isAccessDenied(response) {
  return response?.status === 401 && ACCESS_REASONS.includes(response.data?.reason)
}

export function lockAccess(response) {
  if (!isAccessDenied(response)) return

  access.locked = true
  access.reason = response.data.reason
}
